import {
  driverNotebookT,
  driverNotebooksT,
  driverNotebookPutT,
  driverNotebookPostT,
  DriverNotebook,
} from "dora-contracts";
import { createErrorReportingAsyncThunk } from "../../helpers";
import axios, { getData } from "../../../axios";
import * as tPromise from "io-ts-promise";
import { createSlice } from "@reduxjs/toolkit";

const prefix = "data/driver-notebooks";

type State = {
  entities: DriverNotebook[];
};

const initialState: State = {
  entities: [],
};

export const loadNotebooks = createErrorReportingAsyncThunk(
  `${prefix}/load-notebooks`,
  async (): Promise<DriverNotebook[]> => {
    return axios
      .get("/api/driver-notebooks")
      .then(getData)
      .then(tPromise.decode(driverNotebooksT));
  }
);

export const createNotebook = createErrorReportingAsyncThunk(
  `${prefix}/create`,
  async (name: string): Promise<DriverNotebook> => {
    return axios
      .post(
        "/api/driver-notebooks",
        driverNotebookPostT.encode({
          name,
        })
      )
      .then(getData)
      .then(tPromise.decode(driverNotebookT));
  }
);

export const updateNotebook = createErrorReportingAsyncThunk(
  `${prefix}/update`,
  async (input: { id: string; content: string }) => {
    return axios.put(
      `/api/driver-notebooks/${input.id}`,
      driverNotebookPutT.encode(input)
    );
  }
);

export const deleteNotebook = createErrorReportingAsyncThunk(
  `${prefix}/delete`,
  async (id: string) => {
    return axios.delete(`/api/driver-notebooks/${id}`);
  }
);

export const saveNotebookPageContent = createErrorReportingAsyncThunk(
  `${prefix}/save-page-content`,
  async (input: { id: string; content: string }) => {
    return axios.put(
      `/api/driver-notebooks/${input.id}/content`,
      input.content
    );
  }
);

const slice = createSlice({
  name: prefix,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadNotebooks.fulfilled, (state, action) => {
        state.entities = action.payload;
      })
      .addCase(createNotebook.fulfilled, (state, action) => {
        state.entities.push(action.payload);
      })
      .addCase(updateNotebook.fulfilled, (state, action) => {
        const { id, content } = action.meta.arg;
        const notebook = state.entities.find((x) => x.id === id);
        if (notebook) {
          notebook.content = content;
        }
      })
      .addCase(deleteNotebook.fulfilled, (state, action) => {
        const id = action.meta.arg;
        state.entities = state.entities.filter((x) => x.id !== id);
      })
  },
});

export default slice.reducer;
